export default __webpack_public_path__ + "static/atlassian-ui-refresh-0a9a8a5b13695616815f4dfc709f603a79949148e910db7c1c75b12791d3814f.png";